<template>
	<div>
		<div class="title">附件上传
			<span class="ml20 red font14">请与业务人员沟通确认投保公司、实际用工单位、职业类别信息无误后上传盖章材料。</span>
		</div>
		<Form :label-width="90" class="mt15 w1000">
			<FormItem 
				label="投保单及人员：" :label-width="110">
				<div class="desc" v-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M1'||info.productCode=='CCIC_EMPLOYER_LIABILITY_M2'">
					请先下载投保单和人员清单，盖上公司公章后再回传，<a @click="download" target="_blank">下载投保单与人员清单</a><br />
					<span v-if="multiple" style="color:red">（一张投保单和一张人员清单，为同一文件不同sheet页，两张都需要分别签字盖章上传）</span>
				</div>
				<div class="desc" v-else-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M3'">
					请先下载投保单、人员清单和参保确认书，盖上公司公章后再回传，<a :href="policyUrl" target="_blank" referrerpolicy="no-referrer">下载投保单</a>
					<a class="ml15" @click="download" target="_blank">下载人员清单</a>
					<a class="ml15" :href="confirmUrl" target="_blank" referrerpolicy="no-referrer">下载参保确认书</a>
					<br />
					<span v-if="multiple" style="color:red">（同时,请上传盖章版人员清单明细及参保确认书）</span>
				</div>
				<div class="desc" v-else-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_M4'">
					请先下载投保单、人员清单和参保确认书，盖上公司公章后再回传，<a href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M4/%E5%A4%A7%E5%9C%B0%E6%8A%95%E4%BF%9D%E5%8D%9510%25.docx" target="_blank" referrerpolicy="no-referrer">下载投保单</a><a class="ml15" @click="download" target="_blank">下载人员清单</a><a class="ml15" href="https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M4/%E5%A4%A7%E5%9C%B0%EF%BC%88%E9%9B%87%E4%B8%BB%E9%99%A9%EF%BC%89%E5%8F%82%E4%BF%9D%E7%A1%AE%E8%AE%A4%E4%B9%A6.docx" target="_blank" referrerpolicy="no-referrer">下载参保确认书</a><br />
					<span v-if="multiple" style="color:red">（同时,请上传盖章版人员清单明细及参保确认书）</span>
				</div>
				<div class="desc" v-else-if="info.productCode=='SUNLIGHT_EMPLOYER_LIABILITY'">
					<span v-if="sunshinePolicyUrl">请先下载投保单和人员清单，盖上公司公章后再回传，</span>
					<span v-else>请先下载人员清单，盖上公司公章后再回传，</span>
					<a v-if="sunshinePolicyUrl" :href="sunshinePolicyUrl" target="_blank" referrerpolicy="no-referrer">下载投保单</a><a class="ml15" @click="download" target="_blank">下载人员清单</a><br />
					<span v-if="!sunshinePolicyUrl" style="color:red">暂不支持下载投保单模板,请联系业务人员</span>
				</div>
				<Form class="policy" :model="form" ref="form" :label-width="0">
					<Form-item 
						class="policy-item" 
						v-for="(p,i) in form.fileList"
						:prop="'fileList.' + i + '.fileUrl'"
						:key="i"
						:rules="{required:true,message:'请上传',trigger:'change'}">
						<UploadImg 
							v-model="p.fileUrl" 
							@on-remove="removeImg(i)"
							@on-success="val=>{uploaded(val, i)}"
							:show-del="form.fileList.length>1" />
						<Input v-model="p.fileUrl" v-show="false"></Input>
					</Form-item>
					<div class="policy-item" v-if="multiple&&form.fileList.length<10">
						<a @click="add">添加</a>
					</div>
				</Form>
			</FormItem>
		</Form>
	</div>
</template>
<script>
import UploadImg from './UploadImg'
export default {
	components:{ UploadImg },
	props:{ 
		info:Object,
		multiple:Boolean
	},
	data () {
		return{
			form:{
				fileList:this.info.fileList.length>0?this.info.fileList:[{
					fileUrl:''
				}]
			}
		}
	},
	computed:{
		// 根据subjectMatter和scheme判断投保单下载链接
		policyUrl() {
			const subjectMatter = this.info.subjectMatter || [];
			// 获取所有scheme值
			const schemes = subjectMatter.map(item => item.scheme).filter(Boolean);
			// 判断是高配还是低配
			// 方案1和2属于高配组，方案3和4属于低配组
			const hasHighConfig = schemes.some(s => s === 'plan1' || s === 'plan2');
			const hasLowConfig = schemes.some(s => s === 'plan3' || s === 'plan4');
			if (hasHighConfig) {
				return 'https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/%E6%81%92%E6%99%9F%E6%BA%90%E6%8A%95%E4%BF%9D%E5%8D%95-%E9%AB%98%E9%85%8D.docx';
			}
			if (hasLowConfig) {
				return 'https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/%E6%81%92%E6%99%9F%E6%BA%90%E6%8A%95%E4%BF%9D%E5%8D%95-%E4%BD%8E%E9%85%8D.docx';
			}
			// 默认返回高配无投保人链接
			return '';
		},
		// 阳光雇主责任险投保单下载链接
		sunshinePolicyUrl() {
			const subjectMatter = this.info.subjectMatter || [];
			const schemes = subjectMatter.map(item => item.scheme).filter(Boolean);
			const extraInfo = this.info.extraInfo || {};
			const isSubjoinProportionAdj = extraInfo.isSubjoinProportionAdj;
			const isCanteenAndDormitoryLiability = extraInfo.isCanteenAndDormitoryLiability;

			const hasPlan80 = schemes.some(s => s === 'plan2');
			const hasPlan50 = schemes.some(s => s === 'plan1');

			if (isSubjoinProportionAdj === true || isSubjoinProportionAdj === true) {
				if (hasPlan80 && isCanteenAndDormitoryLiability) {
					return 'https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/%E6%8A%95%E4%BF%9D%E5%8D%95-%E4%BA%BA%E8%B5%84%E9%9B%87%E4%B8%BB-80%E4%B8%87-%E6%8B%93%E5%B1%95-10%25.xlsx';
				}
				if (hasPlan50 && !isCanteenAndDormitoryLiability) {
					return 'https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/%E6%8A%95%E4%BF%9D%E5%8D%95-%E4%BA%BA%E8%B5%84%E9%9B%87%E4%B8%BB-50%E4%B8%87-%E4%B8%8D%E6%8B%93%E5%B1%95-10%25.xlsx';
				}
				if (hasPlan80 && !isCanteenAndDormitoryLiability) {
					return 'https://file.haierbx.net/INDUSTRY_ENTERPRISE/SUNLIGHT_EMPLOYER_LIABILITY/%E6%8A%95%E4%BF%9D%E5%8D%95-%E4%BA%BA%E8%B5%84%E9%9B%87%E4%B8%BB-80%E4%B8%87-%E4%B8%8D%E6%8B%93%E5%B1%95-10%25.xlsx';
				}
			}

			return '';
		},
		confirmUrl(){
			const subjectMatter = this.info.subjectMatter || [];
			// 获取所有scheme值
			const schemes = subjectMatter.map(item => item.scheme).filter(Boolean);
			// 判断是高配还是低配
			// 方案1和2属于高配组，方案3和4属于低配组
			const hasHighConfig = schemes.some(s => s === 'plan1' || s === 'plan2');
			const hasLowConfig = schemes.some(s => s === 'plan3' || s === 'plan4');
			if (hasHighConfig) {
				return 'https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/%E5%A4%A7%E5%9C%B0%EF%BC%88%E9%9B%87%E4%B8%BB%E9%99%A9%EF%BC%89%E5%8F%82%E4%BF%9D%E7%A1%AE%E8%AE%A4%E4%B9%A6-%E9%AB%98%E9%85%8D.docx';
			}
			if (hasLowConfig) {
				return 'https://file.haierbx.net/SERVICE_PLATFORM/CCIC_EMPLOYER_LIABILITY_M3/%E5%A4%A7%E5%9C%B0%EF%BC%88%E9%9B%87%E4%B8%BB%E9%99%A9%EF%BC%89%E5%8F%82%E4%BF%9D%E7%A1%AE%E8%AE%A4%E4%B9%A6-%E4%BD%8E%E9%85%8D.docx';
			}
			return '';
		}
	},
	methods:{
		uploaded(file, index){
			let obj = {
				fileUrl:file.url,
				fileName:file.name,
				fileType:'APPLICATION'
			}
			this.$set(this.form.fileList, index, obj)
		},
		async val () {
			let flag = await this.$refs.form.validate();
			if(!flag)return;
			return new Promise((resolve,reject)=>{
				resolve(this.form)
			})
		},
		add () {
			this.form.fileList.push({
				fileUrl:''
			})
		},
		removeImg (i) {
			this.form.fileList.splice(i,1);
		},
		// 下载模板
		download() {
			this.$axios.post('/broker/export/exportApplication.json',{
				bizId: this.info.bizId,
				productCode: this.info.productCode,
				applicationId: this.$route.params.id
			}).then(res=>{
				if(res){
					this.getBlob(res).then((blob) => {
						this.saveAs(blob, '人员列表')
					})
				}
			})
		},
		getBlob(url) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest()
				xhr.open('GET', url, true)
				xhr.responseType = 'blob'
				xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response)
				}
				}
				xhr.send()
			})
		},
		// 自定义下载文件名称
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				const body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob) // 创建对象url
				link.download = filename

				// fix Firefox
				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)

				window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
			}
		}
	},
	// watch:{
	// 	'info.fileList' (v) {
	// 		this.form.fileList = v;
	// 	}
	// }
}
</script>
<style scoped>
	.policy{
		display:flex;
	}
	.policy-item{
		margin-right: 15px;
	}
	.font14{
		font-size: 14px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/sunshineUpload.vue